import store from 'client/store';

export default function accountPageGuard(to, from, next, storeInstance = store) {
  const { path } = to;
  const settingsModule = 'SettingsModule';
  const isProviderOrg = storeInstance.getters[`${settingsModule}/isProviderOrg`];

  const hasBilling = storeInstance.getters[`${settingsModule}/hasBilling`];
  let route; // undefined means continue;

  // Don't stop a logout
  if (path.indexOf('/logout') === 0) {
    next();
    return;
  }

  if (path.indexOf('/account') === 0 && (!hasBilling || isProviderOrg)) {
    // If we're trying to hit the account page, bounce out to home
    route = '/home';
  }

  next(route);
}
